<template>
  <div id="app">
      <!-- 認証済みの時はメインの画面を表示 -->
      <div v-if="signedIn" class="app-container">
        <el-container style="height: 100vh; border: 1px solid #eee">
          <!--ヘッダ-->
          <HeaderContent v-bind:username="username" :menuHandler="activeMenu" :badgeInfo="badgeInfo" @signOut="signOut" @menuHandler="menuHandler"></HeaderContent>
          <el-container>
            <!--左サイドのメニュー-->
            <el-aside width="180px" :class="{active:activeMenu}">
                <div>
                  <el-menu background-color="#f5f5f5" :default-active="activeIndex" @select="hiddenMenu">
                    <router-link to="/"><el-menu-item index="Report">レポート</el-menu-item></router-link>
                    <router-link to="/previous_data"><el-menu-item index="PreviousData">過去データ</el-menu-item></router-link>
                    <el-submenu index="/option">
                      <template slot="title">オプション</template>
                      <router-link to="/option/configuration"><el-menu-item index="Configuration">設定</el-menu-item></router-link>
                      <router-link to="/option/qa"><el-menu-item index="QA">よくある質問</el-menu-item></router-link>
                    </el-submenu>
                    <el-menu-item index="Logout" v-if="device === 'sp'" @click="signOutSp">ログアウト</el-menu-item>
                  </el-menu>
              
                  <!--アラート中のカメラ-->
                  <AlertStreamList @manageBadge="manageBadge" @clickStream="hiddenMenu"></AlertStreamList>
                </div>

                <el-row type="flex" justify="center" class="row-bg under-logo">
                  <img src="@/img/logo_footer.png" />
                </el-row>
            </el-aside>
            
            <el-main :class="{active: activeMenu}">
              <!--ブラックアウト(sp)-->
              <div class="js-modal-bk" @click="hiddenMenu" :class="{active: activeMenu}" v-if="device === 'sp'"></div>
              <!--各機能ページ-->
              <router-view @signOut="signOut"></router-view>
            </el-main>
          </el-container>
        </el-container>
      </div>


      <!-- 認証していない時はログイン画面を表示 -->
      <div v-else style="height: 100vh; background-color: #E4E7ED" class="login-container">
        <el-container>
          <el-main>
            <el-row type="flex" justify="center" class="row-bg">
              <Login></Login>
            </el-row>
          </el-main>
        </el-container>
      </div>
  </div>
</template>

<script>
import { Auth } from 'aws-amplify'
import { AmplifyEventBus } from 'aws-amplify-vue'
import HeaderContent from '@/components/HeaderContent.vue'
import Login from '@/components/Login.vue'
import AlertStreamList from '@/components/AlertStreamList.vue'
import mixin from '@/mixin/mixin.js'

export default {
  name: 'app',
  mixins: [mixin],
  components: {
    HeaderContent,
    Login,
    AlertStreamList
  },

  data(){
    return {
      signedIn: false,
      username: '',
      activeMenu: false,
      badgeInfo: {}
    }
  },
  
  computed: {
    activeIndex: function(){
      return this.$route.name
    }
  },

  methods: {
    signOut: function(){
      AmplifyEventBus.$emit("authState", 'signedOut')
    },
    getData: async function() {
      // DynamoDBからデータを取得
      let reportPromise = this.$store.dispatch('getReportData').catch(e => this.$message.error(e.message));
      let realtimePromise = this.$store.dispatch('getRealtimeData').catch(e => this.$message.error(e.message));
      await reportPromise
      await realtimePromise
    },
    menuHandler: function(isShowMenu) {
      this.activeMenu = isShowMenu
    },
    hiddenMenu: function() {
      this.activeMenu = false
    },
    manageBadge: function(msg) {
      if (msg === "danger") {
        // 赤アラート検知
        this.$set(this.badgeInfo, 'badgeString', 'x')
        this.$set(this.badgeInfo, 'hiddenBadge', false)
      } else if(msg === "warning") {
        // 黄アラート検知
        this.$set(this.badgeInfo, 'badgeString', '!')
        this.$set(this.badgeInfo, 'hiddenBadge', false)
      } else {
        this.$set(this.badgeInfo, 'badgeString', '')
        this.$set(this.badgeInfo, 'hiddenBadge', true)
      }
      this.$set(this.badgeInfo, 'badgeType', msg)
    },
    signOutSp: async function() {
      try {
        await Auth.signOut();
        this.signOut()

      } catch (error) {
          console.log('error signing out: ', error);
      }
    },
    touchEventHandler: function(event) {
      event.preventDefault();
    }
  },
  
  beforeDestroy: function() {
    clearInterval(this.polling)
  },

  async beforeCreate() {
    // Auth.currentAuthenticatedUser()でユーザ情報を取得する。
    // 取得できなければ認証ステータスをfalseに設定する
    try {
      let cognitoUser = await Auth.currentAuthenticatedUser()
      this.signedIn = true
      this.username = cognitoUser.username
      this.getData();
      this.polling = setInterval(() => {
        this.getData();
      }, 60000)

    } catch (err) {
      this.signedIn = false
      this.username = ""
      await this.$store.dispatch('initialize');
      
      clearInterval(this.polling)

    }

    // 認証ステータスが変わった時に呼び出されるイベントを登録
    AmplifyEventBus.$on('authState', async  info => {
      if (info === 'signedIn') {
        let cognitoUser = await Auth.currentAuthenticatedUser()
        this.signedIn = true
        this.username = cognitoUser.username
        
        // 「過去データ」表示時、キャッシュに起因する？バグ回避のため一度リロード
        document.location.reload()

        this.getData();
        this.polling = setInterval(() => {
          this.getData();
        }, 60000)

      } else {
        this.signedIn = false
        this.username = ""
        await this.$store.dispatch('initialize');

        clearInterval(this.polling)

      }
    });
    
  },
  watch: {
    // menu表示時、ブラックアウト箇所のスクロール制御(spのみ)
    activeMenu(bool) {
      if (bool) {
        // スクロール禁止
        document.getElementsByTagName('main')[0].addEventListener('touchmove', this.touchEventHandler, { passive: false });
        document.getElementsByTagName('main')[0].addEventListener('mousewheel', this.touchEventHandler, { passive: false });
      } else {
        // スクロール禁止解除
        document.getElementsByTagName('main')[0].removeEventListener('touchmove', this.touchEventHandler, { passive: false });
        document.getElementsByTagName('main')[0].removeEventListener('mousewheel', this.touchEventHandler, { passive: false });
      }
    }
  }
  
};
</script>

<style>
  html{
    height: 100%;
  }
  body{
    margin: 0px;
    height: 100%;
  }
</style>

<style scoped>

  .el-aside {
    position: fixed;
    background-color: #f5f5f5;
    top: 60px;
    left: 0;
    height: calc(100vh - 60px);
    display: flex;
    flex-direction: column;
  }

  .el-submenu .el-menu-item{
    min-width: 0;
  }
  
  .el-aside a {
    text-decoration: none;
  }
  
  .app-container .el-main{
    position: fixed;
    top: 60px;
    bottom: 0;
    left: 180px;
    right: 0;
    padding: 10px;
  }
  
  .row-bg {
    padding: 10px 0;
  }
  
  .menubar-logo {
    margin-bottom: 60px;
  }

  .main-logo {
    margin-bottom: 60px;
  }

  .under-logo{
    margin-top: auto;
  }
  
  /* sp版 */
  @media screen and (max-width: 980px) {
    .el-aside {
      left: auto;
      right: 0;
      transform: translateX(100%);
      transition: all .3s;
    }
    
    .el-aside.active {
      transform: translateX(0);
    }
    
    .el-menu {
      padding-top: 10px;
    }
    
    .app-container .el-main{
      position: fixed;
      top: 60px;
      bottom: 0;
      left: 0px;
      padding: 10px;
      transform: translateX(0);
      transition: all .3s;
    }
    
    .el-main.active {
      transform: translateX(-180px);
    }
    
    .el-menu-item {
      height: 35px;
      line-height: 35px;
    }
    
    .js-modal-bk {
      opacity: 0;
      visibility: hidden;
      position: fixed;
      z-index: 12;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: rgba(0, 0, 0, 0.4);
      transition: all .3s;
    }
    
    .js-modal-bk.active {
      opacity: 1;
      visibility: visible;
      overflow: hidden;
      height: 500vh;
      min-height: 2000px;
    }
  }

</style>
